import React from 'react';
import { Grid, Card, CardContent, Box, Typography } from '@mui/material';
import { TrendingUp, Money, AccountBalance, CalendarToday } from '@mui/icons-material';
import { LoadingWrapper } from '../loading';

const PayrollStatsCards = ({ stats, isLoading }) => {
  const formatCompactCurrencyInMillions = (amount, currency = 'PKR') => {
    const numericAmount = Number(amount) || 0;
    const amountInMillions = (numericAmount / 1000000).toFixed(1);
    return `${currency} ${amountInMillions}m`;
  };

  const statsCards = [
    {
      title: 'Total Payrolls',
      value: stats.total_payrolls || 0,
      icon: <TrendingUp />,
      color: 'primary.main',
    },
    {
      title: 'Total Gross Pay',
      value: formatCompactCurrencyInMillions(stats.total_gross_pay),
      icon: <Money />,
      color: 'success.main',
    },
    {
      title: 'Total Net Pay',
      value: formatCompactCurrencyInMillions(stats.total_net_pay),
      icon: <AccountBalance />,
      color: 'info.main',
    },
    {
      title: 'This Month',
      value: stats.current_month_payrolls || 0,
      icon: <CalendarToday />,
      color: 'warning.main',
    },
  ];

  return (
    <LoadingWrapper loading={isLoading} type="skeleton">
      {statsCards.map((stat, index) => (
        <Grid item xs={12} sm={6} md={3} key={index}>
          <Card>
            <CardContent>
              <Box display="flex" alignItems="center">
                <Box
                  sx={{
                    backgroundColor: stat.color,
                    borderRadius: 2,
                    p: 1,
                    mr: 2,
                  }}
                >
                  {React.cloneElement(stat.icon, { sx: { color: 'white' } })}
                </Box>
                <Box>
                  <Typography variant="h6">{stat.value}</Typography>
                  <Typography variant="body2" color="textSecondary">
                    {stat.title}
                  </Typography>
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </LoadingWrapper>
  );
};

export default PayrollStatsCards;
